<template>
  <div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                {{ $t('button.dismiss') }}
              </v-btn>
              <v-btn color="red accent-4" class="white--text" @click="deleteFromDatabase">
                {{ $t('button.confirm') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="reajusteDialog" persistent max-width="500">
          <v-card v-if="reajusteAlvo">
            <v-card-title class="headline">{{ $t('contractV2.warnings.adjustTitle') }}</v-card-title>
            <v-card-text>
              {{
                $t('contractV2.warnings.adjustConfirm', {
                  indicador: reajusteAlvo.aviso.indicador,
                  percentual: String(reajusteAlvo.aviso.percentual).replace('.', ','),
                  data: reajusteAlvo.aviso.data.split('-').reverse().join('/'),
                  contrato: reajusteAlvo.item.cod_contrato,
                })
              }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :disabled="reajustando" @click="reajusteDialog = false">
                {{ $t('button.dismiss') }}
              </v-btn>
              <v-btn color="primary" :loading="reajustando" @click="aplicarReajuste">
                {{ $t('contractV2.warnings.adjust') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialog" max-width="100%">
      <v-card>
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="formValidado">
              <!-- Card 1: Dados Gerais -->
              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3 d-flex align-center justify-space-between">
                  <span>{{ $t('contract.sections.generalData') }}</span>
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="editedItem.padrao"
                      :label="$t('contract.defaultForReports')"
                      :hint="$t('contract.defaultForReportsHint')"
                      persistent-hint
                      :true-value="1"
                      :false-value="0"
                      class="mt-0 pt-0 mr-4"
                    ></v-switch>
                    <v-switch
                      v-model="editedItem.ativo"
                      :label="$t('contract.active')"
                      class="mt-0 pt-0"
                      hide-details
                    ></v-switch>
                  </div>
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row v-if="editedIndex === -1 && canUsarTemplate && templates.length">
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="idTemplate"
                      :items="templates"
                      :label="$t('contractTemplate.useTemplate')"
                      item-value="id_template"
                      item-text="nome"
                      :hint="$t('contractTemplate.useTemplateHint')"
                      persistent-hint
                      clearable
                      :loading="carregandoTemplate"
                      @change="aplicaTemplate"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6" v-if="avisosTemplate.length">
                    <v-alert dense text type="warning" class="mb-0">
                      <div v-for="(aviso, i) in avisosTemplate" :key="'aviso-' + i">{{ aviso }}</div>
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field
                      v-model="editedItem.cod_contrato"
                      :label="$t('contract.contractCode')"
                      :rules="[(v) => (!!v && v.length <= 15) || $t('contract.messages.codeRequired')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="editedItem.id_cliente"
                      :items="clientes"
                      :label="$t('contract.client')"
                      item-value="id_cliente"
                      item-text="nome_cliente"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="editedItem.id_empresa"
                      :items="empresasPermitidas"
                      :label="$t('contract.company')"
                      item-value="id_empresa"
                      item-text="razao_social"
                      :rules="[(v) => !!v || $t('contractV2.messages.companyRequired')]"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <!--
                      Restrição do contrato a algumas unidades. Sempre visível:
                      deixou de ser exclusiva dos modos México/MeliBrasil.
                    -->
                    <v-autocomplete
                      v-model="editedItem.id_unidades"
                      :items="unidades"
                      :label="$t('contract.unit')"
                      item-value="id_unidade"
                      item-text="descricao_unidade"
                      multiple
                      chips
                      deletable-chips
                      clearable
                      :hint="$t('contractV2.unitsHint')"
                      persistent-hint
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.descricao"
                      :label="$t('contract.description')"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Card 2: Vigência e Classificação -->
              <v-card class="pa-4 mb-4" outlined>
                <v-card-title class="text-h6 pa-0 mb-3">
                  {{ $t('contract.sections.validityClassification') }}
                </v-card-title>
                <v-divider class="mb-3"></v-divider>
                <v-row>
                  <v-col cols="12" sm="6" md="2">
                    <v-datetime-picker
                      :label="$t('contract.startValidity')"
                      v-model="dti"
                      :key="'dti-' + datePickerKey"
                      :time-picker-props="timeProps"
                      :text-field-props="textFieldProps"
                      time-format="HH:mm:ss"
                      date-format="dd/MM/yyyy"
                      :clear-text="$t('button.close')"
                    >
                      <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                      <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                    </v-datetime-picker>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-datetime-picker
                      :label="$t('contract.endValidity')"
                      v-model="dtf"
                      :key="'dtf-' + datePickerKey"
                      :time-picker-props="timeProps"
                      :text-field-props="textFieldProps"
                      time-format="HH:mm:ss"
                      date-format="dd/MM/yyyy"
                      :clear-text="$t('button.close')"
                    >
                      <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                      <template slot="timeIcon"><v-icon>mdi-clock</v-icon></template>
                    </v-datetime-picker>
                  </v-col>
                  <!--
                    O ciclo de pagamento vive aqui, e não num card de valores:
                    ele diz em que período o contrato fecha, não quanto vale.
                  -->
                  <v-col cols="12" sm="6" md="2">
                    <v-select
                      v-model="editedItem.tipo_ciclo_pagamento"
                      :items="tipoCicloPagamentoItems"
                      :label="$t('contract.paymentCycle.type')"
                      item-value="value"
                      item-text="text"
                      @change="normalizeCicloPagamentoFields(editedItem)"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <!-- Escolhido ao criar; na edição o contrato mantém o modelo da criação. -->
                    <v-select
                      v-model="editedItem.modelo_mao_obra"
                      :items="modeloMaoObraItems"
                      :label="$t('contractV2.laborModel')"
                      :disabled="editedIndex !== -1"
                      :hint="$t('contractV2.laborModelHint')"
                      :persistent-hint="editedIndex !== -1"
                      item-value="value"
                      item-text="text"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloMensal">
                    <v-text-field
                      v-model.number="editedItem.dia_ciclo_pagamento"
                      :label="$t('contract.paymentCycle.closingDay')"
                      type="number"
                      min="1"
                      max="28"
                      hide-spin-buttons
                      clearable
                      :hint="$t('contract.paymentCycle.closingDayHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloDias">
                    <v-text-field
                      v-model.number="editedItem.dias_ciclo_pagamento"
                      :label="$t('contract.paymentCycle.dayCount')"
                      type="number"
                      min="1"
                      max="366"
                      hide-spin-buttons
                      :rules="[(v) => (v != null && v !== '' && Number(v) >= 1 && Number(v) <= 366) || $t('contract.paymentCycle.dayCountRequired')]"
                      :hint="$t('contract.paymentCycle.dayCountHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" v-if="isCicloQuinzenal || isCicloDias">
                    <v-text-field
                      v-model="editedItem.dt_referencia_ciclo"
                      :label="$t('contract.paymentCycle.anchorDate')"
                      type="date"
                      :hint="isCicloDias ? $t('contract.paymentCycle.anchorDateHintDays') : $t('contract.paymentCycle.anchorDateHint')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="editedItem.prazo_pagamento_dias"
                      :label="$t('contract.conditions.paymentTermDays')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="editedItem.idade_media_frota_anos"
                      :label="$t('contract.conditions.fleetAverageAge')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="editedItem.distancia_max_viagem_m"
                      :label="$t('contract.conditions.maxTripDistance')"
                      type="number"
                      min="0"
                      step="1"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="editedItem.tempo_viagem_min"
                      :label="$t('contract.conditions.tripTime')"
                      type="number"
                      min="0"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-text-field
                      v-model.number="editedItem.valor_preposto"
                      :label="$t('contract.conditions.representativeValue')"
                      type="number"
                      min="0"
                      step="0.01"
                      prefix="$"
                      hide-spin-buttons
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-switch
                      v-model="editedItem.time_atendimento"
                      :true-value="1"
                      :false-value="0"
                      :label="$t('contract.conditions.serviceTeam')"
                      class="mt-2"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="2">
                    <v-switch
                      v-model="editedItem.linhas_intermunicipais"
                      :true-value="1"
                      :false-value="0"
                      :label="$t('contract.conditions.intercityLines')"
                      class="mt-2"
                    ></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-autocomplete
                      v-model="editedItem.id_indicadores_reajuste"
                      :items="indicadoresReajusteItems"
                      :label="$t('contract.conditions.adjustmentIndicators')"
                      item-value="id_indicador"
                      item-text="rotulo"
                      :loading="carregandoIndicadores"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4">
                    <!-- Cada tipo escolhido aqui abre um card de valores abaixo. -->
                    <v-autocomplete
                      v-model="editedItem.id_tipos_veiculos"
                      :items="tiposVeiculos"
                      :label="$t('contractV2.vehicleTypes')"
                      item-value="id_tipo_veiculo"
                      item-text="descricao_tipo_veiculo"
                      multiple
                      chips
                      deletable-chips
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2" v-if="canAplicarReajuste && avisosReajusteDoContrato.length">
                    <v-btn
                      v-for="aviso in avisosReajusteDoContrato"
                      :key="'rj-' + aviso.id_indicador"
                      color="primary"
                      small
                      block
                      class="mb-1"
                      @click="abrirReajuste(editedItem, aviso)"
                    >
                      {{ $t('contractV2.warnings.adjustWith', { indicador: aviso.indicador }) }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Um card por tipo de veículo selecionado -->
              <contrato-tipo-veiculo-card
                v-for="idTipo in editedItem.id_tipos_veiculos"
                :key="'tv-' + idTipo"
                :tipo-veiculo="tipoVeiculoPorId(idTipo)"
                :linhas="valoresPorTipo[idTipo] || []"
                :tarifas="tiposTarifas"
                :grandezas="calculosGrandeza"
                :calculos="calculosFiltro"
                :readonly="!canEditValores"
                :can-criar-tarifa="canCriarTarifa"
                :modelo-mao-obra="editedItem.modelo_mao_obra"
                :faixas-mao-obra="(faixasPorTipo[idTipo] || {}).faixas_mao_obra || {}"
                @update:faixas="$set(faixasPorTipo, idTipo, $event)"
                @update:linhas="setLinhas(idTipo, $event)"
                @add-linha="adicionaLinha(idTipo)"
                @criar-tarifa="abreNovaTarifa($event)"
              />
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="close">
            {{ $t('button.cancel') }}
          </v-btn>
          <v-btn color="primary darken-1" class="white--text" :loading="salvando" @click="save">
            {{ $t('button.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <nova-tarifa-dialog
      v-model="novaTarifaDialog"
      :descricao-inicial="novaTarifaTexto"
      :categorias="categoriasTarifas"
      @created="onTarifaCriada"
    />

    <v-container max-width="100%" style="margin-top: 2%">
      <merus-data-table
        :headers="headers"
        :items="contratosGrid"
        :loading="loading"
        :loading-text="$t('contract.loadingContracts')"
        @update:displayedItems="displayedItemsForExport = $event"
        cod-tabela="CONTRATOSV2"
        @update:headers="headers = $event"
      >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('contractV2.title')"
            :token="token"
            :items="displayedItemsForExport !== null ? displayedItemsForExport : contratosGrid"
            :csv-title="$t('contractV2.title')"
            :csv-headers="headers"
            :pdf-title="$t('contractV2.title')"
            :pdf-headers="headers"
            :pdf-filename="$t('contractV2.title')"
            hide-search
          >
            <template v-slot:add v-if="canInsert">
              <v-btn color="primary" dark small class="mb-2" fab @click="openNewItem">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </cadastro-toolbar>
        </template>
        <template v-slot:item.avisos="{ item }">
          <span v-if="!item.avisos || !item.avisos.length">-</span>
          <template v-else>
            <v-tooltip bottom v-for="(aviso, idx) in item.avisos" :key="idx">
              <template v-slot:activator="{ on, attrs }">
                <v-chip x-small outlined class="mr-1 my-1" :color="avisoCor(aviso)" v-bind="attrs" v-on="on">
                  {{ $t('contractV2.warnings.' + aviso.tipo) }}
                </v-chip>
              </template>
              <span>{{ avisoDetalhe(aviso) }}</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mr-2"
            color="red"
            @click="deleteItem(item)"
            :disabled="item.ativo == 0 || !canDelete"
          >mdi-delete</v-icon>
        </template>
      </merus-data-table>
    </v-container>
  </div>
</template>

<script>
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import ContratoTipoVeiculoCard from './Contratos/ContratoTipoVeiculoCard.vue';
import NovaTarifaDialog from './Contratos/NovaTarifaDialog.vue';
import translateDbField from '@/utils/translateDbField';
import { aceitaComoFiltroLinha, aceitaComoGrandezaLinha } from '../utils/subsidioFinalidadeCalculo';

/**
 * Cadastro de contratos de subsídio com valores por tipo de veículo.
 *
 * O valor deixa de ser um número solto no contrato: cada tipo de veículo é um
 * card, e cada linha do card é `valor × grandeza`, opcionalmente restrita por
 * um filtro. Convive com a tela antiga (/contratos), que continua atendendo os
 * contratos de CONTROLE — esta trata só OPERACIONAIS.
 */
export default {
  name: 'CRUDContratosSubsidioV2',
  components: {
    MerusDataTable,
    CadastroToolbar,
    ContratoTipoVeiculoCard,
    NovaTarifaDialog,
  },
  data: () => ({
    headers: [],
    displayedItemsForExport: null,
    user: null,
    token: null,
    loading: false,
    salvando: false,
    formValidado: true,
    dialog: false,
    confirmDialog: false,
    mensagemdialog: '',
    operacao: 0,

    contratos: [],
    clientes: [],
    unidades: [],
    tiposVeiculos: [],
    tiposTarifas: [],
    categoriasTarifas: [],
    calculosGrandeza: [],
    calculosFiltro: [],
    recursos: [],
    empresasPermitidas: [],

    canInsert: false,
    canEdit: false,
    canDelete: false,
    canEditValores: false,
    canCriarTarifa: false,
    canUsarTemplate: false,
    canVerIndicadores: false,
    canAplicarReajuste: false,
    reajusteDialog: false,
    reajusteAlvo: null,
    reajustando: false,
    indicadoresReajuste: [],
    carregandoIndicadores: false,

    // Template escolhido no contrato novo: as linhas já resolvidas para os ids
    // do banco, aplicadas a cada tipo de veículo no lugar das linhas padrão.
    templates: [],
    idTemplate: null,
    modeloTemplate: null,
    avisosTemplate: [],
    carregandoTemplate: false,

    dti: null,
    dtf: null,
    datePickerKey: 0,
    textFieldProps: { prependInnerIcon: 'mdi-calendar' },
    timeProps: { useSeconds: true },

    editedIndex: -1,
    editedItem: {},
    deletedItem: {},

    // Linhas fora do editedItem: `close()` recria o item por clone do default,
    // e um mapa aninhado não sobreviveria bem a esse reset.
    valoresPorTipo: {},
    // Regime e preços das faixas de mão de obra por tipo, pela mesma razão.
    faixasPorTipo: {},
    // Guarda as linhas de um tipo desmarcado: desmarcar por engano e remarcar
    // não pode custar o trabalho já preenchido.
    valoresPorTipoCache: {},

    novaTarifaDialog: false,
    novaTarifaTexto: '',
    novaTarifaAlvo: null,
  }),
  computed: {
    // Inativo só aparece habilitado se já está entre os escolhidos.
    // Reajustes cujo prazo chegou; o botão fica ao lado dos tipos de veículo.
    avisosReajusteDoContrato() {
      return ((this.editedItem && this.editedItem.avisos) || []).filter((a) => a.pode_reajustar);
    },
    indicadoresReajusteItems() {
      const escolhidos = this.editedItem.id_indicadores_reajuste || [];
      const itens = this.indicadoresReajuste.map((i) => ({
        ...i,
        rotulo: i.codigo + ' — ' + i.nome,
        disabled: i.ativo != 1 && !escolhidos.includes(i.id_indicador),
      }));
      return itens;
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('contractV2.newContract')
        : this.$t('contractV2.editContract');
    },
    /** Contratos com a lista de tipos de veículo traduzida, quando o cadastro já carregou. */
    contratosGrid() {
      if (!this.tiposVeiculos.length) return this.contratos;
      const porId = new Map(this.tiposVeiculos.map((t) => [Number(t.id_tipo_veiculo), t.descricao_tipo_veiculo]));
      return this.contratos.map((c) => {
        const ids = c.ids_tipos_veiculos || [];
        if (!ids.length) return c;
        const nomes = ids.map((id) => porId.get(Number(id))).filter((n) => n);
        return nomes.length === ids.length ? { ...c, tipos_veiculos_extenso: nomes.join(', ') } : c;
      });
    },
    isCicloMensal() {
      return (this.editedItem.tipo_ciclo_pagamento || 'MENSAL') === 'MENSAL';
    },
    isCicloQuinzenal() {
      return this.editedItem.tipo_ciclo_pagamento === 'QUINZENAL';
    },
    isCicloDias() {
      return this.editedItem.tipo_ciclo_pagamento === 'DIAS';
    },
    modeloMaoObraItems() {
      return [
        { value: 'PADRAO', text: this.$t('contractV2.laborModelDefault') },
        { value: 'FAIXAS', text: this.$t('contractV2.laborModelRanges') },
      ];
    },
    tipoCicloPagamentoItems() {
      return [
        { value: 'MENSAL', text: this.$t('contract.paymentCycle.monthly') },
        { value: 'QUINZENAL', text: this.$t('contract.paymentCycle.biweekly') },
        { value: 'DIAS', text: this.$t('contract.paymentCycle.customDays') },
      ];
    },
    defaultItem() {
      return {
        id_contrato: null,
        tipo_contrato: 'OPERACIONAL',
        cod_contrato: null,
        descricao: null,
        observacoes: null,
        dt_inicio: null,
        dt_fim: null,
        id_cliente: null,
        id_empresa: null,
        ativo: 1,
        padrao: 0,
        id_tipos_veiculos: [],
        id_unidades: [],
        modelo_mao_obra: 'PADRAO',
        tipo_ciclo_pagamento: 'MENSAL',
        dia_ciclo_pagamento: null,
        dias_ciclo_pagamento: null,
        dt_referencia_ciclo: null,
        prazo_pagamento_dias: null,
        idade_media_frota_anos: null,
        distancia_max_viagem_m: null,
        tempo_viagem_min: null,
        time_atendimento: 0,
        linhas_intermunicipais: 0,
        valor_preposto: null,
        id_indicadores_reajuste: [],
      };
    },
  },
  watch: {
    'editedItem.id_tipos_veiculos': function (novos, antigos) {
      const atuais = novos || [];
      (antigos || []).forEach((id) => {
        if (atuais.indexOf(id) !== -1) return;
        this.$set(this.valoresPorTipoCache, id, this.valoresPorTipo[id] || []);
        this.$delete(this.valoresPorTipo, id);
      });
      atuais.forEach((id) => {
        if (this.valoresPorTipo[id]) return;
        this.$set(
          this.valoresPorTipo,
          id,
          this.valoresPorTipoCache[id] || this.linhasIniciais(id),
        );
      });
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user'));
    this.token = sessionStorage.getItem('api');
    this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
    this.deletedItem = JSON.parse(JSON.stringify(this.defaultItem));
    this._uid_linha = 0;
    this.populaRecursos();
    this.initialize();
    const resposta = parseInt(this.$route.query.resposta, 10);
    if (Number.isFinite(resposta)) this.aplicaResposta(resposta);
  },
  methods: {
    avisoCor(aviso) {
      return { error: 'red', warning: 'orange', info: 'blue' }[aviso.severidade] || 'grey';
    },
    avisoDetalhe(aviso) {
      const data = aviso.data ? aviso.data.split('-').reverse().join('/') : '';
      return this.$t('contractV2.warnings.' + aviso.tipo + 'Detail', {
        data,
        indicador: aviso.indicador,
        dias: aviso.dias,
        quantidade: aviso.quantidade,
        idade: aviso.idade_limite,
        percentual: aviso.percentual == null ? '' : String(aviso.percentual).replace('.', ','),
      });
    },
    abrirReajuste(item, aviso) {
      this.reajusteAlvo = { item, aviso };
      this.reajusteDialog = true;
    },
    aplicarReajuste() {
      const { item, aviso } = this.reajusteAlvo;
      this.reajustando = true;
      return apiController
        .request(apiController.endpoints.subsidioAplicarreajustecontrato, {
          data: { id_contrato: item.id_contrato, id_indicador: aviso.id_indicador, dt_reajuste: aviso.data },
          onSuccess: (response) => {
            this.reajusteDialog = false;
            // Os valores abertos no formulário ficaram defasados: fecha sem salvar.
            if (!response.data.erro && this.dialog) this.close();
            EventBus.$emit('show-alert', {
              mensagem: response.data.erro
                ? response.data.mensagem
                : this.$t('contractV2.warnings.adjustDone', { indicador: aviso.indicador }),
              tipo: response.data.erro ? 'error' : 'success',
            });
            this.populaContratos();
          },
        })
        .catch(() => {})
        .finally(() => {
          this.reajustando = false;
        });
    },
    initialize() {
      this.populaContratos();
      this.populaClientes();
      this.populaUnidades();
      this.populaTiposTarifas();
      this.populaCategoriasTarifas();
      this.populaCalculos();
    },

    // ----- catálogos -------------------------------------------------------

    /**
     * Carrega uma lista de apoio sem derrubar a tela se ela falhar.
     *
     * `apiController.request` rejeita a promise mesmo quando `onError` é
     * informado, então sem o catch um catálogo indisponível vira
     * "Uncaught (in promise)" e interrompe o resto da carga. O erro em si já é
     * mostrado ao usuário pelo EventBus dentro do próprio apiController.
     */
    carregaLista(endpoint, aplica) {
      return apiController
        .request(endpoint, {
          onSuccess: (response) => {
            aplica(Array.isArray(response.data) ? response.data : []);
          },
        })
        .catch(() => {});
    },
    populaContratos() {
      this.loading = true;
      return apiController
        .request(apiController.endpoints.subsidioGetallContratossubsidio, {
          onSuccess: (response) => {
            const lista = Array.isArray(response.data) ? response.data : [];
            // Contrato de CONTROLE continua na tela antiga.
            this.contratos = lista.filter(
              (c) => (c.tipo_contrato || 'OPERACIONAL') === 'OPERACIONAL',
            );
            this.loading = false;
          },
          onError: () => {
            this.loading = false;
          },
        })
        .catch(() => {});
    },
    populaClientes() {
      this.carregaLista(apiController.endpoints.getallClientes, (lista) => {
        this.clientes = lista.filter((c) => c.ativo === 1 || c.ativo === true || c.ativo == null);
      });
    },
    populaUnidades() {
      this.carregaLista(apiController.endpoints.getallUnidades, (lista) => {
        this.unidades = lista.filter((u) => u.ativa == 1);
      });
    },
    populaTiposVeiculos() {
      this.carregaLista(apiController.endpoints.getallTiposveiculos, (lista) => {
        this.tiposVeiculos = lista.map((tipoVeiculo) => ({
          ...tipoVeiculo,
          descricao_tipo_veiculo: translateDbField(
            tipoVeiculo.translation_key,
            tipoVeiculo.descricao_tipo_veiculo,
          ),
        }));
      });
    },
    populaTiposTarifas() {
      this.carregaLista(apiController.endpoints.getallTipostarifas, (lista) => {
        this.tiposTarifas = lista;
      });
    },
    populaCategoriasTarifas() {
      this.carregaLista(apiController.endpoints.getallCategoriastarifas, (lista) => {
        this.categoriasTarifas = lista;
      });
    },
    populaCalculos() {
      this.carregaLista(apiController.endpoints.subsidioMotorCalculos, (lista) => {
        this.calculosFiltro = lista.filter((c) => aceitaComoFiltroLinha(c.finalidade));
        // A grandeza da linha é um cálculo de finalidade GRANDEZA.
        this.calculosGrandeza = lista.filter((c) => aceitaComoGrandezaLinha(c.finalidade));
      });
    },
    populaRecursos() {
      const aplica = (response, superadmin) => {
        this.recursos = response.data || [];
        const tem = (rota) => this.recursos.some((r) => r.rota === rota);
        this.canEdit = superadmin || tem('/api/v1.0/subsidio/updatecontratosubsidio');
        this.canInsert = superadmin || tem('/api/v1.0/subsidio/insertcontratosubsidio');
        this.canDelete = superadmin || tem('/api/v1.0/subsidio/deletecontratosubsidio');
        this.canEditValores =
          superadmin || tem('/api/v1.0/subsidio/setvalorescontratotipoveiculo');
        this.canCriarTarifa = superadmin || tem('/api/v1.0/inserttipotarifa');
        this.canUsarTemplate =
          superadmin || tem('/api/v1.0/subsidio/getcontratotemplate');
        this.canAplicarReajuste =
          superadmin || tem('/api/v1.0/subsidio/aplicarreajustecontrato');
        this.canVerIndicadores =
          superadmin || tem('/api/v1.0/subsidio/getallindicadoresreajuste');
        this.populaTemplates();
        if (this.canVerIndicadores) this.populaIndicadoresReajuste();
        this.populaEmpresasPermitidas();
        // Os tipos de veículo dependem das empresas permitidas, que saem daqui.
        this.populaTiposVeiculos();
      };

      const superadmin = this.user.is_superadmin === 1;
      const endpoint = superadmin
        ? apiController.endpoints.getallRecursos
        : apiController.endpoints.getRecursosusuario;
      const opcoes = { onSuccess: (response) => aplica(response, superadmin) };
      if (!superadmin) opcoes.params = { id: this.user.id_usuario };

      return apiController.request(endpoint, opcoes).catch(() => {});
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos
        .filter((r) => r.id_empresa)
        .map((rec) => ({ id_empresa: rec.id_empresa, razao_social: rec.razao_social }));
    },

    // ----- linhas e cards --------------------------------------------------

    tipoVeiculoPorId(id) {
      return (
        this.tiposVeiculos.find((t) => Number(t.id_tipo_veiculo) === Number(id)) || {
          id_tipo_veiculo: id,
          descricao_tipo_veiculo: null,
        }
      );
    },
    proximoUid() {
      this._uid_linha += 1;
      return this._uid_linha;
    },
    linhaVazia(idTarifa, ordem) {
      return {
        uid: this.proximoUid(),
        id_tarifa: idTarifa || null,
        valor: null,
        id_calculo_grandeza: null,
        id_calculo_filtro: null,
        ordem,
      };
    },
    /**
     * As três linhas clássicas — fixo, variável e mão de obra —, uma por
     * categoria de tarifa. São só um ponto de partida: nada impede remover uma
     * delas ou acrescentar outras.
     */
    linhasPadrao() {
      return [1, 2, 3]
        .map((idCategoria) => this.primeiraTarifaDaCategoria(idCategoria))
        .filter((t) => !!t)
        .map((tarifa, idx) => this.linhaVazia(tarifa.id_tarifa, idx));
    },
    /**
     * Linhas de um tipo de veículo recém-escolhido: as que o template define
     * para o tipo; se não define, as três linhas clássicas.
     */
    linhasIniciais(idTipo) {
      const modelo = this.modeloTemplate;
      if (!modelo) return this.linhasPadrao();
      const doTipo = (modelo.tipos_veiculo || []).find(
        (t) => Number(t.id_tipo_veiculo) === Number(idTipo),
      );
      if (!doTipo) return this.linhasPadrao();
      return doTipo.linhas.map((l, idx) => ({
        uid: this.proximoUid(),
        id_tarifa: l.id_tarifa,
        valor: l.valor == null ? null : Number(l.valor),
        id_calculo_grandeza: l.id_calculo_grandeza,
        id_calculo_filtro: l.id_calculo_filtro,
        ordem: idx,
      }));
    },
    limpaTemplate() {
      this.idTemplate = null;
      this.modeloTemplate = null;
      this.avisosTemplate = [];
    },
    // Catálogo pequeno: uma página só, com os inativos (o contrato pode já
    // estar associado a um indicador desativado depois).
    populaIndicadoresReajuste() {
      this.carregandoIndicadores = true;
      return apiController.request(apiController.endpoints.subsidioGetallIndicadoresreajuste, {
        data: { page: 1, rowsPerPage: 1000, total: 'true', sortBy: 'nome', sortDesc: 'false' },
        onSuccess: (response) => {
          const data = response.data;
          this.indicadoresReajuste = Array.isArray(data && data.items) ? data.items : [];
        },
      })
        .catch(() => {})
        .finally(() => {
          this.carregandoIndicadores = false;
        });
    },
    populaTemplates() {
      if (!this.canUsarTemplate) return;
      this.carregaLista(apiController.endpoints.subsidioGetallContratotemplates, (lista) => {
        this.templates = lista.filter((t) => t.ativo === 1 || t.ativo === true);
      });
    },
    /**
     * Pré-preenche o formulário com o template: todos os campos do contrato
     * que o template define e as linhas de cada tipo de veículo. Campo que o
     * template deixa em branco não apaga o que o usuário já digitou. Nada é
     * gravado aqui — o usuário ainda edita e confirma.
     */
    async aplicaTemplate(idTemplate) {
      if (!idTemplate) {
        this.limpaTemplate();
        return;
      }
      this.carregandoTemplate = true;
      try {
        const response = await apiController.request(
          apiController.endpoints.subsidioGetContratotemplate,
          { params: { id: idTemplate }, silent: true },
        );
        this.aplicaModelo((response.data && response.data.resolvido) || {});
      } catch (e) {
        this.limpaTemplate();
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.carregandoTemplate = false;
      }
    },
    /**
     * Abre um contrato novo pré-preenchido com a resposta de um cliente a um
     * template enviado (`?resposta=<id_envio>` na rota). Mesmo preenchimento do
     * template, com os valores que o cliente informou. Nada é gravado.
     */
    async aplicaResposta(idEnvio) {
      this.carregandoTemplate = true;
      try {
        await this.aguardaCatalogos();
        const response = await apiController.request(
          apiController.endpoints.subsidioGetEnviotemplatecontratorevisao,
          { params: { id: idEnvio }, silent: true },
        );
        this.openNewItem();
        this.aplicaModelo((response.data && response.data.resolvido) || {});
        EventBus.$emit('show-alert', {
          mensagem: this.$t('contractV2.answerPrefilled', { user: response.data.nome_usuario_destino }),
          tipo: 'info',
        });
      } catch (e) {
        this.limpaTemplate();
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.carregandoTemplate = false;
        // Evita reabrir o contrato ao recarregar a página.
        this.$router.replace({ path: this.$route.path }).catch(() => {});
      }
    },
    // O preenchimento filtra por cadastros que o usuário enxerga: espera as listas chegarem.
    aguardaCatalogos() {
      const prontos = () =>
        this.recursos.length && this.unidades.length && this.tiposVeiculos.length && this.tiposTarifas.length;
      return new Promise((resolve) => {
        const inicio = Date.now();
        const tenta = () => {
          if (prontos() || Date.now() - inicio > 10000) resolve();
          else setTimeout(tenta, 150);
        };
        tenta();
      });
    },
    aplicaModelo(modelo) {
      {
        this.modeloTemplate = modelo;
        this.avisosTemplate = modelo.avisos || [];

        const preenche = (campo, valor) => {
          if (valor == null || valor === '') return;
          this.$set(this.editedItem, campo, valor);
        };
        ['cod_contrato', 'descricao', 'observacoes', 'dt_referencia_ciclo'].forEach((c) =>
          preenche(c, modelo[c]),
        );
        // Empresa e cliente só valem se o usuário ainda os enxerga.
        if (this.empresasPermitidas.some((e) => Number(e.id_empresa) === Number(modelo.id_empresa))) {
          preenche('id_empresa', modelo.id_empresa);
        }
        if (this.clientes.some((c) => Number(c.id_cliente) === Number(modelo.id_cliente))) {
          preenche('id_cliente', modelo.id_cliente);
        }
        const unidades = (modelo.id_unidades || []).filter((id) =>
          this.unidades.some((u) => Number(u.id_unidade) === Number(id)),
        );
        if (unidades.length) this.$set(this.editedItem, 'id_unidades', unidades);
        this.$set(this.editedItem, 'ativo', modelo.ativo == 0 ? 0 : 1);
        this.$set(this.editedItem, 'padrao', modelo.padrao == 1 ? 1 : 0);
        this.$set(this.editedItem, 'modelo_mao_obra', modelo.modelo_mao_obra === 'FAIXAS' ? 'FAIXAS' : 'PADRAO');
        this.faixasPorTipo = {};
        (modelo.tipos_veiculo || []).forEach((tv) => {
          this.$set(this.faixasPorTipo, tv.id_tipo_veiculo, {
            faixas_mao_obra: Object.assign({}, tv.faixas_mao_obra),
          });
        });
        this.$set(this.editedItem, 'tipo_ciclo_pagamento', modelo.tipo_ciclo_pagamento || 'MENSAL');
        this.$set(this.editedItem, 'dia_ciclo_pagamento', modelo.dia_ciclo_pagamento);
        this.$set(this.editedItem, 'dias_ciclo_pagamento', modelo.dias_ciclo_pagamento);
        ['prazo_pagamento_dias', 'idade_media_frota_anos', 'distancia_max_viagem_m', 'tempo_viagem_min', 'valor_preposto'].forEach((c) =>
          preenche(c, modelo[c]),
        );
        this.$set(this.editedItem, 'time_atendimento', modelo.time_atendimento == 1 ? 1 : 0);
        this.$set(this.editedItem, 'linhas_intermunicipais', modelo.linhas_intermunicipais == 1 ? 1 : 0);
        if ((modelo.id_indicadores_reajuste || []).length) {
          this.$set(this.editedItem, 'id_indicadores_reajuste', modelo.id_indicadores_reajuste.slice());
        }
        this.normalizeCicloPagamentoFields(this.editedItem);
        if (modelo.dt_inicio) {
          this.dti = modelo.dt_inicio;
          this.datePickerKey += 1;
        }
        if (modelo.dt_fim) {
          this.dtf = modelo.dt_fim;
          this.datePickerKey += 1;
        }

        // Tipos de veículo: os do template (que o usuário enxerga) mais os que
        // ele já tinha marcado. As linhas são refeitas para todos.
        const doTemplate = (modelo.id_tipos_veiculos || []).filter((id) =>
          this.tiposVeiculos.some((t) => Number(t.id_tipo_veiculo) === Number(id)),
        );
        const atuais = this.editedItem.id_tipos_veiculos || [];
        const uniao = atuais.concat(doTemplate.filter((id) => atuais.indexOf(id) === -1));
        this.valoresPorTipoCache = {};
        uniao.forEach((id) => {
          this.$set(this.valoresPorTipo, id, this.linhasIniciais(id));
        });
        this.$set(this.editedItem, 'id_tipos_veiculos', uniao);
      }
    },
    primeiraTarifaDaCategoria(idCategoria) {
      return (this.tiposTarifas || []).find(
        (t) => Number(t.id_categoria) === Number(idCategoria),
      );
    },
    setLinhas(idTipo, linhas) {
      this.$set(this.valoresPorTipo, idTipo, linhas);
    },
    adicionaLinha(idTipo) {
      const atuais = (this.valoresPorTipo[idTipo] || []).slice();
      atuais.push(this.linhaVazia(null, atuais.length));
      this.$set(this.valoresPorTipo, idTipo, atuais);
    },
    abreNovaTarifa(evento) {
      this.novaTarifaAlvo = evento;
      this.novaTarifaTexto = evento.texto || '';
      this.novaTarifaDialog = true;
    },
    onTarifaCriada(tarifa) {
      this.tiposTarifas = this.tiposTarifas.concat([tarifa]);
      const alvo = this.novaTarifaAlvo;
      if (!alvo) return;
      const linhas = (this.valoresPorTipo[alvo.idTipoVeiculo] || []).slice();
      if (linhas[alvo.indice]) {
        linhas.splice(
          alvo.indice,
          1,
          Object.assign({}, linhas[alvo.indice], { id_tarifa: tarifa.id_tarifa }),
        );
        this.$set(this.valoresPorTipo, alvo.idTipoVeiculo, linhas);
      }
      this.novaTarifaAlvo = null;
    },

    // ----- ciclo de pagamento ---------------------------------------------

    normalizeCicloPagamentoFields(item) {
      if (!item) return;
      if (!item.tipo_ciclo_pagamento) {
        this.$set(item, 'tipo_ciclo_pagamento', 'MENSAL');
      }
      if (item.dt_referencia_ciclo && String(item.dt_referencia_ciclo).length > 10) {
        this.$set(item, 'dt_referencia_ciclo', String(item.dt_referencia_ciclo).substring(0, 10));
      }
      if (item.tipo_ciclo_pagamento === 'QUINZENAL') {
        this.$set(item, 'dia_ciclo_pagamento', null);
        this.$set(item, 'dias_ciclo_pagamento', null);
      } else if (item.tipo_ciclo_pagamento === 'DIAS') {
        this.$set(item, 'dia_ciclo_pagamento', null);
      } else if (item.tipo_ciclo_pagamento === 'MENSAL') {
        this.$set(item, 'dt_referencia_ciclo', null);
        this.$set(item, 'dias_ciclo_pagamento', null);
      }
    },

    // ----- abertura / fechamento ------------------------------------------

    openNewItem() {
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.valoresPorTipo = {};
      this.faixasPorTipo = {};
      this.valoresPorTipoCache = {};
      this.limpaTemplate();
      this.dti = null;
      this.dtf = null;
      this.dialog = true;
    },
    async editItem(item) {
      this.editedIndex = this.contratos.findIndex(
        (c) => String(c.id_contrato) === String(item.id_contrato),
      );
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(this.defaultItem)), item);
      this.editedItem.padrao =
        item.padrao === true || item.padrao === 1 || item.padrao === '1' ? 1 : 0;
      this.normalizeCicloPagamentoFields(this.editedItem);
      this.dti = item.dt_inicio_extenso;
      this.dtf = item.dt_fim_extenso;
      this.valoresPorTipo = {};
      this.faixasPorTipo = {};
      this.valoresPorTipoCache = {};
      this.limpaTemplate();
      this.editedItem.id_tipos_veiculos = [];
      this.editedItem.id_unidades = [];

      try {
        await Promise.all([
          this.carregaValores(item.id_contrato),
          this.carregaUnidades(item.id_contrato),
        ]);
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      }
      this.dialog = true;
    },
    async carregaValores(idContrato) {
      const response = await apiController.request(
        apiController.endpoints.subsidioGetValorescontratotipoveiculo,
        { params: { idcontrato: idContrato }, silent: true },
      );
      const tipos = Array.isArray(response.data) ? response.data : [];
      const ids = [];
      tipos.forEach((tipo) => {
        ids.push(tipo.id_tipo_veiculo);
        this.$set(this.faixasPorTipo, tipo.id_tipo_veiculo, {
          faixas_mao_obra: tipo.faixas_mao_obra || {},
        });
        this.$set(
          this.valoresPorTipo,
          tipo.id_tipo_veiculo,
          (tipo.linhas || []).map((l, idx) => ({
            uid: this.proximoUid(),
            id_tarifa: l.id_tarifa,
            valor: l.valor == null ? null : Number(l.valor),
            id_calculo_grandeza: l.id_calculo_grandeza,
            id_calculo_filtro: l.id_calculo_filtro,
            ordem: l.ordem == null ? idx : l.ordem,
          })),
        );
      });
      // Atribuído depois das linhas: o watcher não pode criar linhas padrão por
      // cima das que acabaram de vir do banco.
      this.editedItem.id_tipos_veiculos = ids;
    },
    async carregaUnidades(idContrato) {
      const response = await apiController.request(
        apiController.endpoints.subsidioGetUnidadesassociadascontrato,
        { params: { idcontrato: idContrato }, silent: true },
      );
      const lista = Array.isArray(response.data) ? response.data : [];
      this.editedItem.id_unidades = lista.map((u) => u.id_unidade);
    },
    close() {
      this.dialog = false;
      if (this.$refs.form && typeof this.$refs.form.resetValidation === 'function') {
        this.$refs.form.resetValidation();
      }
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
        this.valoresPorTipo = {};
        this.faixasPorTipo = {};
        this.valoresPorTipoCache = {};
        this.limpaTemplate();
        this.dti = null;
        this.dtf = null;
        this.datePickerKey += 1;
      });
    },

    // ----- gravação --------------------------------------------------------

    buildTiposVeiculoPayload() {
      return (this.editedItem.id_tipos_veiculos || []).map((idTipo, idxTipo) => ({
        id_tipo_veiculo: idTipo,
        ordem: idxTipo,
        // Só contrato FAIXAS grava regime/preços; os demais seguem sem eles.
        ...(this.editedItem.modelo_mao_obra === 'FAIXAS'
          ? this.faixasPorTipo[idTipo] || {}
          : {}),
        linhas: (this.valoresPorTipo[idTipo] || [])
          .filter((l) => l.id_tarifa != null)
          .map((l, idx) => ({
            id_tarifa: l.id_tarifa,
            valor: l.valor,
            id_calculo_grandeza: l.id_calculo_grandeza,
            id_calculo_filtro: l.id_calculo_filtro,
            ordem: idx,
          })),
      }));
    },
    /**
     * Devolve a mensagem do primeiro problema nas linhas, ou null.
     * Espelha `validateSetValoresPayload` do backend, para o usuário saber do
     * erro antes de o contrato já ter sido gravado.
     */
    validaLinhas() {
      const tipos = this.buildTiposVeiculoPayload();
      for (let i = 0; i < tipos.length; i += 1) {
        const faixas = tipos[i].faixas_mao_obra || {};
        if (Object.keys(faixas).some((col) => faixas[col] != null && Number(faixas[col]) < 0)) {
          return this.$t('contractV2.messages.negativeLaborRange');
        }
        const vistas = new Set();
        for (let j = 0; j < tipos[i].linhas.length; j += 1) {
          const linha = tipos[i].linhas[j];
          if (vistas.has(Number(linha.id_tarifa))) {
            return this.$t('contractV2.messages.duplicateTariff');
          }
          vistas.add(Number(linha.id_tarifa));
          if (linha.valor != null && Number(linha.valor) < 0) {
            return this.$t('contractV2.messages.negativeValue');
          }
          if (linha.id_calculo_grandeza == null) {
            return this.$t('contractV2.messages.magnitudeRequired');
          }
        }
      }
      return null;
    },
    buildContratoApiPayload() {
      const p = Object.assign({}, this.editedItem);
      p.dt_inicio = DateUtils.getDateSQLFormatted(this.dti);
      p.dt_fim = DateUtils.getDateSQLFormatted(this.dtf);
      p.tipo_contrato = 'OPERACIONAL';
      // A estrutura nova substitui estas colunas; o contrato criado aqui nasce
      // sem elas e é a tabela de valores que responde pelo número.
      p.valor_km = null;
      p.valor_fixo = null;
      p.valor_variavel = null;
      p.valor_mao_de_obra = null;
      p.id_tarifa = null;
      p.id_tarifa_fixa = null;
      p.id_tarifa_labor = null;
      p.id_tipo_veiculo = null;
      delete p.id_tipos_veiculos;
      delete p.dt_inicio_extenso;
      delete p.dt_fim_extenso;
      delete p.dt_inclusao_extenso;
      delete p.ativo_extenso;
      delete p.padrao_extenso;
      delete p.vigente;
      delete p.vigente_extenso;
      delete p.nome_cliente;
      delete p.razao_social;
      delete p.descricao_tarifa;
      delete p.descricao_tipo_veiculo;
      delete p.cod_indicadores_reajuste;
      delete p.nomes_indicadores_reajuste;
      delete p.tipos_veiculos_extenso;
      delete p.ids_tipos_veiculos;
      delete p.qtd_filhos;
      delete p.avisos;
      return p;
    },
    async save() {
      this.$refs.form.validate();
      if (!this.formValidado) return;

      const erroLinhas = this.validaLinhas();
      if (erroLinhas) {
        EventBus.$emit('show-alert', { mensagem: erroLinhas, tipo: 'error' });
        return;
      }

      this.normalizeCicloPagamentoFields(this.editedItem);
      this.salvando = true;
      const criando = this.editedIndex === -1;
      this.operacao = criando ? 0 : 1;

      try {
        let idContrato = this.editedItem.id_contrato;
        const endpoint = criando
          ? apiController.endpoints.subsidioInsertContratosubsidio
          : apiController.endpoints.subsidioUpdateContratosubsidio;
        const response = await apiController.request(endpoint, {
          data: this.buildContratoApiPayload(),
          silent: true,
        });
        if (response.data && response.data.erro) {
          EventBus.$emit('show-alert', { mensagem: response.data.mensagem, tipo: 'error' });
          return;
        }
        if (criando) idContrato = response.data.insertId;

        // Sem transação entre as chamadas: se esta falhar, o contrato já está
        // gravado e sem linhas. A mensagem tem de dizer isso, senão o usuário
        // acha que perdeu tudo.
        try {
          await apiController.request(
            apiController.endpoints.subsidioSetvalorescontratotipoveiculo,
            {
              data: { id_contrato: idContrato, tipos_veiculo: this.buildTiposVeiculoPayload() },
              silent: true,
            },
          );
        } catch (e) {
          EventBus.$emit('show-alert', {
            mensagem: this.$t('contractV2.messages.savedContractButNotValues'),
            tipo: 'error',
          });
          throw e;
        }

        await this.salvaUnidades(idContrato);

        EventBus.$emit('show-alert', {
          mensagem: criando
            ? this.$t('contract.messages.success.insert')
            : this.$t('contract.messages.success.update'),
          tipo: 'success',
        });
        this.close();
        this.populaContratos();
      } catch (e) {
        EventBus.$emit('show-error', { error: e });
      } finally {
        this.salvando = false;
      }
    },
    async salvaUnidades(idContrato) {
      await apiController.request(apiController.endpoints.subsidioDeleteAllunidadescontrato, {
        data: { id_contrato: idContrato },
        silent: true,
      });
      const unidades = this.editedItem.id_unidades || [];
      if (!unidades.length) return;
      await apiController.request(apiController.endpoints.subsidioInsertUnidadescontratossubsidio, {
        data: unidades.map((idUnidade) => [idContrato, idUnidade]),
        silent: true,
      });
    },

    // ----- exclusão --------------------------------------------------------

    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      this.operacao = 2;
      this.mensagemdialog = this.$t('contractV2.messages.confirmDelete', {
        code: item.cod_contrato,
      });
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      apiController
        .request(apiController.endpoints.subsidioDeleteContratosubsidio, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.confirmDialog = false;
          EventBus.$emit('show-alert', {
            mensagem: response.data.erro
              ? this.$t('contract.messages.error.delete') + response.data.mensagem
              : this.$t('contract.messages.success.delete'),
            tipo: response.data.erro ? 'error' : 'success',
          });
          this.populaContratos();
        },
          onError: () => {
            this.confirmDialog = false;
          },
        })
        .catch(() => {});
    },
  },
};
</script>
